<section class="database-page">
	<section class="content-area">
		<lvr-tabs class="tab-content-container">
			<lvr-tab [icon]="'analytics'" [route]="['/wiki']" [isActive]="true" [showDestroyButton]="false">
				{{ 'update_page.title' | transloco }}
			</lvr-tab>
		</lvr-tabs>

		<section class="tab-content">
			<section class="status-updates">
				@if (statusResource.isLoading()) {
					<p class="status-updates-hint">{{ 'update_page.status_loading' | transloco }}</p>
				} @else if (statusResource.error()) {
					<p class="status-updates-error">
						{{ 'update_page.status_error ' | transloco }}
					</p>
				} @else if (statusResource.value()) {
					<p class="status-updates-meta">
						{{ 'update_page.last_status_update' | transloco }}
						{{ statusResource.value()!.exportedAt | date: 'dd.MM.y, HH:mm' }}
					</p>
					<div class="status-updates-content" [innerHtml]="statusResource.value()!.content | safeMarkdown"></div>
				} @else {
					<p class="status-updates-hint">{{ 'update_page.status_empty' | transloco }}</p>
				}
			</section>
		</section>
	</section>
</section>
